import React, { useState } from "react";
import { COMPANION_OPTIONS } from "../utils/companionPlay";

export default function CompanionSetup({ onCompanionTurn, onSkip }) {
  const [companion, setCompanion] = useState(COMPANION_OPTIONS[0]); // { label: "Mom", emoji: "👩" }
  const [custom, setCustom] = useState("");

  const name = custom.trim() || companion.label;

  return (
    <div className="flex flex-col items-center gap-5 py-10 px-4 text-center max-w-sm mx-auto">
      <div className="text-5xl" aria-hidden="true">🎈</div>
      <h2 className="text-xl font-extrabold text-yellow-200">Who's playing with you today?</h2>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
        {COMPANION_OPTIONS.map((opt) => (
            <button
            key={opt.label}
            onClick={() => { setCompanion(opt); setCustom(""); }}
            className={[
                "w-full flex items-center justify-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-semibold transition-colors",
                companion.label === opt.label && !custom ? "bg-[#7C3AED] text-white" : "bg-white/10 text-white/80",
            ].join(" ")}
            >
            <span className="text-lg" aria-hidden="true">{opt.emoji}</span>
            {opt.label}
            </button>
        ))}
      </div>

      <input
        type="text"
        value={custom}
        onChange={(e) => setCustom(e.target.value)}
        placeholder="Or type a name…"
        className="w-full max-w-[220px] text-center bg-white/10 text-white placeholder-white/50 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#7C3AED]"
      />

      <div className="w-full space-y-2 pt-2">
        <button
          onClick={() => onCompanionTurn(name)}
          className="w-full bg-[#FF8B6B] hover:bg-[#F97A57] text-white font-bold rounded-2xl py-3.5 text-base shadow-sm transition-colors"
        >
          {custom.trim() ? "🧑" : companion.emoji} {name} Start Your Turn 🎮
        </button>
        <button onClick={onSkip} className="w-full text-sm font-semibold text-white/70 py-2">
          Skip — Let's Just Play! →
        </button>
      </div>
    </div>
  );
}